module.exports = __webpack_public_path__ + "img/all-bg.af7a8034.png";